import styled from 'styled-components';
export const StyledProgressWrapper = styled.span `
  margin-right: 0.5rem;
  width: 1.25rem;
  height: 1.25rem;
`;
